module.exports = __webpack_public_path__ + "static/img/3.23f39d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/3.jpg
// module id = 8OVZ
// module chunks = 1